// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestSearchResults-cls1_glI","cls2":"ResearchInterestSearchResults-cls2_scx ResearchInterestSearchResults-cls1_glI"};